import styled from 'styled-components';

export const Bar = styled.div`
    height: 4px;
    width: 26px;
    border-radius: 3px;
    background-color: #214781;
`;

export const BarWrapper = styled.div`
    gap: 4px;
    padding: 10px 5px;
    display: flex;
    flex-direction: column;
    @media screen and (min-width: 769px) {
        display: none;
    }
`;

export const CloseIcon = styled.img`
    cursor: pointer;
    align-self: flex-start;
    height: 36px;
    width: 36px;
    border-radius: 16px;
    color: #0a4a8d;
    margin-top: 21px;
    margin-left: 29px;
    margin-bottom: 20px;
`;

export const MenuContainer = styled.div`
    display: flex;
    opacity: 0.66;
    background-color: #000;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vw;
    position: absolute;
`;

export const MenuWrapper = styled.div`
    display: flex;
    width: 236px;
    flex-direction: column;
    gap: 25px;
    background-color: #0a4a8d;
`;
export const Container = styled.div`
    height: 100vh;
    left: 0;
    top: 0;
    position: absolute;
    display: flex;
    z-index: 1000;

    @media screen and (min-width: 769px) {
        display: none;
    }
`;

export const EmptyWrapper = styled.div`
    background-color: #000;
    width: 100vw;
    opacity: 0.66;
    pointer-events: none;
`;
